import { render, staticRenderFns } from "./downloadList.vue?vue&type=template&id=5069add7&scoped=true"
import script from "./downloadList.vue?vue&type=script&lang=js"
export * from "./downloadList.vue?vue&type=script&lang=js"
import style0 from "./downloadList.vue?vue&type=style&index=0&id=5069add7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5069add7",
  null
  
)

export default component.exports